import React, { useState, useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//API
import ItemService from "../../../../services/customer_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/CustomerConstants";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import {
  getTodaysData,
  isValidNumber,
  validateRequired,
  // validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import Loader from "../../../../Components/Loader";
import { getPurchaseRequisition } from "../../../../redux/feature/supplier_app/sourcingSlice";
import CustomerConstants from "../../../../common/CustomerConstants";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const CreateIndentV2 = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Project");
  localStorage.setItem("submenu", "Create Indent");

  let userData = useSelector((state) => state?.user); // User Details from Store
  // JSON Object
  const [formInputs, setFormInputs] = useState({
    companyCode: "SVA - SRI VENKATESWARA AGENCIES ",
    companyCodeCode: "SVA",
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    indentDocumentType: "IN",
    version: "V0",
    inqHeaderstatus: "New",
    salesDocumentGroup: "IN",
    customerCode: userData?.data?.userId,
    customerName: userData?.data?.firstName,
    indentCategory: "",
    indentDocumentDate: getTodaysData() || "",
    requestDeliveryDate: getTodaysData() || "",
    salesOrg: "",
    salesGroup: "",

    // incoTerms: "",
    // incoTermsLocation: "",
    purchasingReqDocumentValue: "",
    indentRemark: "",

    headerTextData: [
      {
        itemIndex: "",
        documentId: "",
        documentText: "",
      },
    ],

    items: [
      {
        indentDocumentItemNr: "",
        itemTextData: [
          {
            itemIndex: "",
            documentId: "",
            documentText: "",
          },
        ],
        materialCode: "",
        inqItemStatus: "New",
        materialDescription: "",
        materialGroup: "",
        indentQuantity: "",
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        netValue: "",
        // deliveryDate: "",
        itemCurrency: "",
        storageLocn: "",
        taxCode: 0,
        taxAmount: 0,
      },
    ],
  });

  const indentTypes = [
    { id: 1, name: "Direct", code: "DIR" },
    { id: 2, name: "Office", code: "OFF" },
  ];
  const buildingRepairWorks = [
    { id: 1, name: "Electrical", code: "ELE" },
    { id: 2, name: "Plumbing", code: "PLM" },
    { id: 3, name: "Wall Crack", code: "WCR" },
    { id: 4, name: "Painting", code: "PNT" },
    { id: 5, name: "Roof Leakage", code: "RLF" },
    { id: 6, name: "Tile / Flooring", code: "FLR" },
    { id: 7, name: "Door & Window Fixing", code: "DWF" },
    { id: 8, name: "Drainage Cleaning", code: "DRN" },
    { id: 10, name: "Labour Charges", code: "LAB" },
    { id: 11, name: "Sand", code: "SAN" },
    { id: 12, name: "Block", code: "BLO" },
    { id: 13, name: "Payments", code: "PAY" },
    { id: 14, name: "Others", code: "OTH" },
  ];

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const modalData = {
    title: "Indent Creation",
    successMsg: "",
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getLoader, setLoader] = useState(true);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureFuelEntry] = useState(false);
  const [getFailureModal] = useState(failureModalData);

  const showPrice = formInputs?.indentTypeCode === "DIR";

  // Inital Create PO
  let POLineItemInitialCol = useMemo(
    () => [
      {
        name: "Item Nr",
        selector: (row) => row.local_id || "--",
        sortable: true,
        width: "180px",
      },

      {
        name: "Material/Service ",
        selector: (row) => row.materialCode || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            // label="Please Enter the Remarks*"
            name="materialCode"
            placeholder=""
            value={row.materialCode || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Description",
        selector: (row) => row.materialDescription || "--",
        cell: (row) => (
          <TextAreaField
            className="inputBox mt-1"
            name="materialDescription"
            placeholder=""
            value={row.materialDescription || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        sortable: true,
        width: "200px",
      },

      {
        name: "Quantity ",
        selector: (row) => row.indentQuantity || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="indentQuantity"
            placeholder=""
            value={row.indentQuantity || ""}
            onChange={(event) =>
              handleInputChange(row.local_id, event, "Number")
            }
          />
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="orderUnitOfMeasure"
            placeholder=""
            value={row.orderUnitOfMeasure || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        width: "200px",
      },

      {
        name: "Price",
        selector: (row) => row?.price ?? "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="price"
            value={row?.price ?? ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        width: "200px",
        // omit: formInputs?.indentTypeCode === "DIR"?true:false,
        omit: !showPrice,
      },

      {
        name: "Site Location",
        selector: (row) => row.storageLocn || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            // label="Please Enter the Remarks*"
            name="storageLocn"
            placeholder=""
            value={row.storageLocn || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Delete",
        selector: (row) => row.local_id || "--",
        sortable: true,
        cell: (row) => (
          <button
            className="btn btn-danger"
            onClick={() => removePOItemRow(row.local_id)}
          >
            <i className="bi bi-trash3"></i>
          </button>
        ),
        width: "120px",
      },
    ],
    [showPrice],
  );

  let POLineItemInitialData = [
    {
      local_id: 1,
      indentDocumentItemNr: 1,
      itemTextData: [],
      inqItemStatus: "In Release",

      taxCode: 0,
      taxAmount: 0,
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);
  const [getPurchaseType, setPurchaseType] = useState(0);
  const [, /*getPurchaseCategory*/ setPurchaseCategory] = useState(0);
  // eslint-disable-next-line
  const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers.map((item) =>
        item.indentDocumentItemNr === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData,
  );
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);
  useEffect(() => {
    setPOLineItemsCol(POLineItemInitialCol);
  }, [POLineItemInitialCol]);

  // eslint-disable-next-line
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  // eslint-disable-next-line
  const [getCompanyCode, setCompanyCode] = useState([]);
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  // eslint-disable-next-line no-unused-vars

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  /* Create PO Line Item Header Text Modal Function */
  // eslint-disable-next-line
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const error = "";
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.code === "MAT") {
      // Material
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
      setPOLineItemsCol(POLineItemInitialCol);
      setPOLineItemsData(POLineItemInitialData);
    } else if (getDropdownData?.textField === "indentType") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
      setPOLineItemsCol(POLineItemInitialCol);
      setPOLineItemsData(POLineItemInitialData);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "indentQuantity"
                      ? row.orderPriceUnit * value
                      : row.indentQuantity * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "indentQuantity"
                      ? row.orderPriceUnit * value
                      : row.indentQuantity * value),
                }
              : row;
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.indentQuantity || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPOLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule
  useEffect(() => {
    const getItemTotal = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.netValue || 0),
      0,
    );
    const taxTotalAmount = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.taxAmount || 0),
      0,
    );

    setTaxAmountValue(taxTotalAmount);
    setItemAmountValue(getItemTotal);

    setSubTotalValue(getItemTotal + taxTotalAmount);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPOLineItemsData]);

  useEffect(() => {
    getMasterDataFunc();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Load Master Data
  const getMasterDataFunc = async () => {
    // 2
    let obj2 = {
      codeType: "purchaseOrganisation",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setPurchaseOrg(item?.data);
      } else {
        setPurchaseOrg([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj12 = {
      codeType: "PrPurchaseType",
    };
    await ItemService.getMasterData(obj12).then((item) => {
      if (item?.status === 200) {
        setPurchaseType(item?.data);
      } else {
        setPurchaseType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj13 = {
      codeType: "PurchaseCategory",
    };
    await ItemService.getMasterData(obj13).then((item) => {
      if (item?.status === 200) {
        setPurchaseCategory(item?.data);
      } else {
        setPurchaseCategory([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj14 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj14).then((item) => {
      if (item?.status === 200) {
        setpurchaseGroup(item?.data);
      } else {
        setpurchaseGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    setLoader(false);
  };

  const hideFailureModal = () => {
    setShowFailureFuelEntry(false);
  };

  const [validation, setValidation] = useState({});

  // SAVE
  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== "",
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.salesType)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        salesType: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.indentType)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        indentType: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.buildingRequirements)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        buildingRequirements: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.siteAddress)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        siteAddress: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    const isValid = validatePOLineItems();
    if (!isValid) {
      toast.error(
        "Please fill all Line Item / Products Details mandatory fields Material/Service, Description, Quantity and Uom",
      );
      return;
    }

    formInputs.items = getPOLineItemsData;
    formInputs.purchasingReqDocumentValue = subTotalValue;
    formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemService.addInquiry(obj).then((item) => {
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        dispatch(getPurchaseRequisition({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const addPOItemRow = () => {
    setPOLineItemsData((prevRows) => {
      POLineItemInitialData[0].local_id = prevRows.length + 1;
      POLineItemInitialData[0].indentDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData];
    });
  };

  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };

  const validatePOLineItems = () => {
    const errors = {};
    let isValid = true;

    getPOLineItemsData.forEach((row) => {
      const rowErrors = {};

      if (!row.materialCode) {
        rowErrors.materialCode = "Please fill the Material/Service";
        isValid = false;
      }

      if (!row.materialDescription) {
        rowErrors.materialDescription = "Please fill the Description";
        isValid = false;
      }

      if (!row.indentQuantity) {
        rowErrors.indentQuantity = "Please fill the Quantity";
        isValid = false;
      }

      if (!row.orderUnitOfMeasure) {
        rowErrors.orderUnitOfMeasure = "Please fill the UOM";
        isValid = false;
      }

      if (showPrice && !row.price) {
        rowErrors.price = "Please fill the Price";
        isValid = false;
      }

      if (Object.keys(rowErrors).length > 0) {
        errors[row.local_id] = rowErrors;
      }
    });

    return isValid;
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Indent</h2>
            <p className="subText">Fill Create Indent Details</p>
            <hr />

            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="indentDocumentType"
                              className="inputBox"
                              label="Document type"
                              name="indentDocumentType"
                              placeholder=""
                              value={formInputs.indentDocumentType} // inquiryDocumentType
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="indentDocumentDate"
                              className="inputBox"
                              label="Requirement Date"
                              name="indentDocumentDate"
                              placeholder=""
                              type="date"
                              value={formInputs.indentDocumentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="inqHeaderstatus"
                              className="inputBox"
                              label="Status"
                              name="inqHeaderstatus"
                              placeholder=""
                              value={formInputs.inqHeaderstatus}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="salesType"
                              label="Order Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="salesType"
                              code="salesTypeCode"
                              setValue={formInputs?.salesType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                              error={validation.salesType || ""}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="companyCode"
                              className="inputBox"
                              label="Company Code"
                              name="companyCode"
                              placeholder=""
                              value={formInputs?.companyCode}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="requestDeliveryDate"
                              className="inputBox"
                              label="Request Delivery Date"
                              name="requestDeliveryDate"
                              placeholder=""
                              type="date"
                              value={formInputs?.requestDeliveryDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="indentType"
                              label="Indent Type"
                              placeholder=""
                              data={indentTypes}
                              iconClassName="dropdownIcon"
                              name="indentType"
                              code="indentTypeCode"
                              description="indentTypeDesc"
                              setValue={formInputs?.indentType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                              error={validation.indentType || ""}
                            />
                          </Col>
                          {formInputs?.indentTypeCode === "DIR" && (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="vendorName"
                                  className="inputBox"
                                  label="Venodr Name"
                                  name="vendorName"
                                  placeholder=""
                                  type="text"
                                  value={formInputs?.vendorName}
                                  onChange={onInputChange}
                                  disabled={getDisabledStatus}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <TextAreaField
                                  id="venodrAddress"
                                  className="inputBox"
                                  label="Venodr Address"
                                  name="venodrAddress"
                                  placeholder=""
                                  value={formInputs.venodrAddress || ""}
                                  onChange={onInputChange}
                                />
                              </Col>
                            </>
                          )}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="buildingRequirements"
                              label="Building Requirements"
                              placeholder=""
                              data={buildingRepairWorks}
                              iconClassName="dropdownIcon"
                              name="buildingRequirements"
                              code="buildingRequirementsCode"
                              description="buildingRequirementsDesc"
                              setValue={formInputs?.buildingRequirements || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                              error={validation.buildingRequirements || ""}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="siteAddress"
                              className="inputBox"
                              label="Site Address"
                              name="siteAddress"
                              placeholder=""
                              value={formInputs.siteAddress || ""}
                              error={validation.siteAddress || ""}
                              required={true}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="indentRemark"
                              className="inputBox"
                              label="Remark"
                              name="indentRemark"
                              placeholder=""
                              value={formInputs.indentRemark || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponent
                              id="supportingDoc"
                              name="supportingDoc"
                              label="Supporting Document"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs.supportingDoc || ""}
                            />
                          </Col>
                          {/* <Row> */}
                          <Col
                            xs={2}
                            md={2}
                            lg={2}
                            className="commLeftRightPadding"
                          >
                            {(formInputs.supportingDoc && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs.supportingDoc)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          {/* </Row> */}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">
                            Line Item / Products Details
                          </span>
                          <span className="subHeaderTitle">
                            Line Item / Products Details
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          <Col xs={4} md={2} lg={2} >
                            <button className="btnTable" onClick={addPOItemRow}>
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        {/* dynamicDropdown */}
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={getPOLineItemsCol}
                              data={getPOLineItemsData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!getLoader && (
        <>
          <Row className="rowDirection mb-4 pb-4">
            <Col xs={12} md={2} lg={2}>
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disabled}
              >
                <i className="bi bi-save"></i> Create
              </button>
            </Col>
          </Row>
        </>
      )}

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={CustomerConstants.CUSTOMER_V2_INDENT_LIST}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CreateIndentV2;
